import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {ResolvedCustomAuthPage} from '@app/custom-auth-pages/custom-auth-page';
import {errorStatusIs} from '@common/http/error-status-is';

interface Response extends BackendResponse {
  page?: ResolvedCustomAuthPage | null;
}

export function useResolvedCustomAuthPage(path: string, enabled = true) {
  return useQuery({
    queryKey: ['custom-auth-page', path],
    queryFn: () => fetchResolvedCustomAuthPage(path),
    enabled,
    retry: false,
  });
}

function fetchResolvedCustomAuthPage(path: string): Promise<Response> {
  return apiClient
    .get<Response>('custom-auth-pages/resolve', {params: {path}})
    .then(response => response.data)
    .catch(error => {
      if (errorStatusIs(error, 404)) {
        return {status: 'success', page: null};
      }
      throw error;
    });
}
